import { createApiRef } from '@backstage/core-plugin-api';

export const externalResourcesApiRef = createApiRef<ExternalResourcesApi>({
  id: 'plugin.external-resources.service',
});

export interface ExternalResourcesApi {
  getExternalResourcesAccessURL(filenames: string[]): Promise<string[]>;
}
